import React, { Fragment } from 'react';
import { BaseButton, Button, Dialog, DialogFooter, DialogType, PrimaryButton } from 'office-ui-fabric-react';




import { WsAlert } from '../core';

import { sanitize } from '../helpers';




import './Alert.scss';




const WsAlertComponent = ({ alert, setAlert }: { alert: WsAlert | undefined, setAlert: React.Dispatch<React.SetStateAction<WsAlert | undefined>>}) => {

  const onDismiss = (ev?: React.MouseEvent<HTMLButtonElement, MouseEvent> | undefined) => {
    setAlert(undefined);
  };

  const onClickOk = (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement | HTMLDivElement | BaseButton | Button | HTMLSpanElement, MouseEvent>) => {
    setAlert(undefined);
  };

  const onClickReload = (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement | HTMLDivElement | BaseButton | Button | HTMLSpanElement, MouseEvent>) => {
    // window.location.href = `${process.env.REACT_APP_REDIRECT_URI}`;
    window.location.replace(`${window.location.href.split('?')[0]}?t=${(new Date()).getTime()}`);
  };

  const alertText = alert && alert.text ? alert.text : '';

  return (
    <Dialog
      hidden={!alert}
      onDismiss={onDismiss}
      dialogContentProps={{
        type: DialogType.normal,
        // title: alert && alert.text ? alert.text : ''
      }}
      modalProps={{
        isBlocking: false,
        className: `ws-alert-dialog ${alert?.className ? alert.className : ''}`,
        styles: {
          // main: { width: '200px' }
        }
      }}
    >
      <Fragment>
        <div className="ws-alert-text">
          {alertText.split('\n').map((item, key) => {
            return <span key={key} dangerouslySetInnerHTML={sanitize(`${item}<br />`, {})} />;
          })}
          <br />
          <br />
        </div>
      </Fragment>
      <DialogFooter>
        {
          alert?.buttons.ok
          &&
          <PrimaryButton onClick={onClickOk} text="OK" />
        }
        {
          alert?.buttons.reload
          &&
          <PrimaryButton onClick={onClickReload} text="Reload" />
        }
      </DialogFooter>
    </Dialog>
  );
};




export {
  WsAlertComponent
};
